module.exports = __webpack_public_path__ + "static/img/20221213_01.3cbb2f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20221213_01.png
// module id = 6ZET
// module chunks = 0